import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface UserExpertise {
  id: string;
  user_id: string;
  industry_name?: string;
  domain_id?: string;
  domain_name: string;
  category_id?: string;
  category: string;
  subcategory: string;
  created_at?: string;
}

export const useUserExpertise = (userId?: string) => {
  return useQuery({
    queryKey: ['user_expertise', userId],
    queryFn: async () => {
      if (!userId) return [];

      const { data, error } = await supabase
        .from('user_expertise')
        .select('*')
        .eq('user_id', userId)
        .order('domain_name', { ascending: true });

      if (error) throw error;
      return data as UserExpertise[];
    },
    enabled: !!userId
  });
};

export const groupExpertiseByDomain = (expertise: UserExpertise[]) => {
  const grouped: Record<string, { category: string; subcategories: string[] }[]> = {};
  
  expertise.forEach((exp) => {
    if (!grouped[exp.domain_name]) {
      grouped[exp.domain_name] = [];
    }
    
    const existingCategory = grouped[exp.domain_name].find(
      (item) => item.category === exp.category
    );
    
    if (existingCategory) {
      if (!existingCategory.subcategories.includes(exp.subcategory)) {
        existingCategory.subcategories.push(exp.subcategory);
      }
    } else {
      grouped[exp.domain_name].push({
        category: exp.category,
        subcategories: [exp.subcategory]
      });
    }
  });
  
  return grouped;
};
